import TabelaSredstva from "./TabelaSredstva";
import ButtonsPocetna from "./ButtonsPocetna";
import { useEffect, useState } from "react";
import DodavanjeSredstva from "./DodavanjeSredstva";
import PreviewSredstvo from "./preview-sredstvo/PreviewSredstvo";

const sredstvaMock = [
  {
    id: "1",
    redniBroj: "1",
    vrsta: {
      id: "1",
      name: "Radna masina"
    },
    tip: "TS1",
    regOznaka: "BG2365V",
    istice: "26.01.02",
    vozac: {
      id: "1",
      name: "Pera Peric"
    },
    status: "green" // "red"/"green"/"orange"
  },
  {
    id: "2",
    redniBroj: "2",
    vrsta: {
      id: "2",
      name: "Viljuskar"
    },
    tip: "TS3",
    regOznaka: "BG2365V",
    istice: "26.01.02",
    vozac: {
      id: "2",
      name: "Mika Mikic"
    },
    status: "red"
  },
  {
    id: "3",
    redniBroj: "3",
    vrsta: {
      id: "3",
      name: "Putnicko"
    },
    tip: "B",
    regOznaka: "BG2365V",
    istice: "26.01.02",
    vozac: {
      id: "1",
      name: "Pera Peric"
    },
    status: "green"
  },
  {
    id: "4",
    redniBroj: "4",
    vrsta: {
      id: "4",
      name: "Dizalica"
    },
    tip: "B",
    regOznaka: "BG2365V",
    istice: "26.01.02",
    vozac: {
      id: "4",
      name: "Zika Zikic"
    },
    status: "orange"
  }
];

function Pocetna() {
  const [sredstva, setSredstva] = useState(sredstvaMock);
  const [isDodavanje, setIsDodavanje] = useState(false);
  const [editData, setEditData] = useState(null);
  const [previewId, setPreviewId] = useState("");

  useEffect(() => {
    setSredstva(sredstvaMock);
  }, [sredstvaMock]);

  const cancelPreview = () => {
    setPreviewId("");
  };

  if (previewId)
    return <PreviewSredstvo id={previewId} cancelPreview={cancelPreview} />;

  return (
    <div
      style={{
        padding: "25px",
        backgroundColor: "#f9f9f9",
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <TabelaSredstva
        sredstva={sredstva}
        setSredstva={setSredstva}
        setEditData={setEditData}
        setPreviewId={setPreviewId}
      />
      {isDodavanje || editData ? (
        <DodavanjeSredstva
          setIsDodavanje={setIsDodavanje}
          setSredstva={setSredstva}
          editData={editData}
          setEditData={setEditData}
        />
      ) : (
        <ButtonsPocetna setIsDodavanje={setIsDodavanje} />
      )}
    </div>
  );
}

export default Pocetna;
